import { TrackingData } from "common/helpers/Analytics";
import { RootState } from "common/reducers";
import { AppDispatch } from "common/store";
import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux";
import { useTracking, Options } from "react-tracking";

// https://redux.js.org/usage/usage-with-typescript#define-typed-hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = () => useStore<RootState>();
export const useAppTracking = (trackingData?: Partial<TrackingData>, options?: Partial<Options<TrackingData>>) =>
  useTracking<TrackingData>(trackingData, options);
